var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverx(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 113,
    height: 48.455,
    viewBox: "0 0 113 48.455",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17c8e7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00d9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#17c8e7",
    stopOpacity: 0.855
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00d9ff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_99",
    x: 16.006,
    y: 0,
    width: 14.848,
    height: 48.455,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00d9ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_100",
    x: 3.702,
    y: 4.734,
    width: 39.792,
    height: 39.792,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00d9ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_101",
    x: 3.701,
    y: 3.929,
    width: 39.792,
    height: 39.791,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00d9ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_102",
    x: 0,
    y: 17.728,
    width: 48,
    height: 14,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00d9ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1bc9e7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_99-2",
    x: 81.006,
    y: 0,
    width: 14.848,
    height: 48.455,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00d9ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_100-2",
    x: 68.702,
    y: 4.734,
    width: 39.792,
    height: 39.792,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00d9ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_101-2",
    x: 68.701,
    y: 3.929,
    width: 39.792,
    height: 39.791,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00d9ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_102-2",
    x: 65,
    y: 17.728,
    width: 48,
    height: 14,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00d9ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_246",
    "data-name": "Group 246",
    transform: "translate(-301 -245.553)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_98",
    "data-name": "Rectangle 98",
    width: 64,
    height: 3,
    transform: "translate(324 268.28)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_244",
    "data-name": "Group 244",
    transform: "translate(-2 -393.72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_243",
    "data-name": "Group 243",
    transform: "translate(13.772 13.772)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 289.23, 625.5)",
    filter: "url(#Rectangle_99)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_99-3",
    "data-name": "Rectangle 99",
    width: 36.455,
    height: 2.848,
    transform: "translate(24.85 6) rotate(90)",
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 289.23, 625.5)",
    filter: "url(#Rectangle_100)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_100-3",
    "data-name": "Rectangle 100",
    width: 36.455,
    height: 2.848,
    transform: "translate(11.72 10.73) rotate(45)",
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 289.23, 625.5)",
    filter: "url(#Rectangle_101)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_101-3",
    "data-name": "Rectangle 101",
    width: 36.455,
    height: 2.848,
    transform: "translate(37.49 11.94) rotate(135)",
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 289.23, 625.5)",
    filter: "url(#Rectangle_102)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_102-3",
    "data-name": "Rectangle 102",
    width: 36,
    height: 2,
    transform: "translate(6 23.73)",
    fill: "url(#radial-gradient-2)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_3",
    "data-name": "Polygon 3",
    d: "M14.142,0l.383,5.475L20,5.858,16.4,10,20,14.142l-5.475.383L14.142,20,10,16.4,5.858,20l-.383-5.475L0,14.142,3.6,10,0,5.858l5.475-.383L5.858,0,10,3.6Z",
    transform: "translate(316 654)",
    fill: "url(#radial-gradient-6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_245",
    "data-name": "Group 245",
    transform: "translate(63 -393.72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_243-2",
    "data-name": "Group 243",
    transform: "translate(13.772 13.772)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 224.23, 625.5)",
    filter: "url(#Rectangle_99-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_99-4",
    "data-name": "Rectangle 99",
    width: 36.455,
    height: 2.848,
    transform: "translate(89.85 6) rotate(90)",
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 224.23, 625.5)",
    filter: "url(#Rectangle_100-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_100-4",
    "data-name": "Rectangle 100",
    width: 36.455,
    height: 2.848,
    transform: "translate(76.72 10.73) rotate(45)",
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 224.23, 625.5)",
    filter: "url(#Rectangle_101-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_101-4",
    "data-name": "Rectangle 101",
    width: 36.455,
    height: 2.848,
    transform: "translate(102.49 11.94) rotate(135)",
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 224.23, 625.5)",
    filter: "url(#Rectangle_102-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_102-4",
    "data-name": "Rectangle 102",
    width: 36,
    height: 2,
    transform: "translate(71 23.73)",
    fill: "url(#radial-gradient-2)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_3-2",
    "data-name": "Polygon 3",
    d: "M14.142,0l.383,5.475L20,5.858,16.4,10,20,14.142l-5.475.383L14.142,20,10,16.4,5.858,20l-.383-5.475L0,14.142,3.6,10,0,5.858l5.475-.383L5.858,0,10,3.6Z",
    transform: "translate(316 654)",
    fill: "url(#radial-gradient-6)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverx);
export default __webpack_public_path__ + "static/media/overx.ff868d56a49bf80a7be58cf5c01a9661.svg";
export { ForwardRef as ReactComponent };